import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs';

export interface DynamicDocumentGridState {
  sourceGridKey: string;
  operation: string;
  rows: any[];
  applicationId?: string | number | null;
  sectionName?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicDocumentBridgeService {
  private readonly states$ = new BehaviorSubject<Record<string, DynamicDocumentGridState>>({});

  publish(state: DynamicDocumentGridState): void {
    const sourceGridKey = String(state?.sourceGridKey || '').trim();
    if (!sourceGridKey) {
      return;
    }

    this.states$.next({
      ...this.states$.value,
      [sourceGridKey]: {
        sourceGridKey,
        operation: state.operation || 'load',
        rows: Array.isArray(state.rows) ? state.rows : [],
        applicationId: state.applicationId ?? null,
        sectionName: state.sectionName ?? null
      }
    });
  }

  watch(sourceGridKey: string): Observable<DynamicDocumentGridState | null> {
    const key = String(sourceGridKey || '').trim();
    return this.states$.pipe(map((states: Record<string, DynamicDocumentGridState>) => states[key] || null));
  }

  getRows(sourceGridKey: string): any[] {
    return this.states$.value[String(sourceGridKey || '').trim()]?.rows || [];
  }
}
